import { render, staticRenderFns } from "./new_astrolabe.vue?vue&type=template&id=84ea1620&scoped=true&"
import script from "./new_astrolabe.vue?vue&type=script&lang=js&"
export * from "./new_astrolabe.vue?vue&type=script&lang=js&"
import style0 from "./new_astrolabe.vue?vue&type=style&index=0&id=84ea1620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ea1620",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84ea1620')) {
      api.createRecord('84ea1620', component.options)
    } else {
      api.reload('84ea1620', component.options)
    }
    module.hot.accept("./new_astrolabe.vue?vue&type=template&id=84ea1620&scoped=true&", function () {
      api.rerender('84ea1620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/星盤組件/new_astrolabe.vue"
export default component.exports